<template lang="pug">
    div
        Button(@click="isImportModalShown=true") {{'匯入表格'}}
        Modal(v-model="isImportModalShown" :title="'匯入域名配置'" width="80" @on-cancel="removeData" footer-hide=true)
            Row(type="flex" justify="space-between")
                Form(:model="formItem" label-position="right" :label-width="100" style="width:100%")
                    Row(type="flex" justify="space-between")
                        Col(span="12")
                            FormItem(label="upload")
                                Upload(
                                    name="uploads"
                                    ref="uploads"
                                    :webkitdirectory="false"
                                    :multiple="false"
                                    :before-upload="beforeUpload"
                                    action="/api/uploads/minio"
                                    :show-upload-list="false"
                                    v-bind:with-credentials="true"
                                    :data="formItem.extraUploadData"
                                    style="line-height: 1.5;"
                                    accept=".csv"
                                    :format=format
                                )
                                    Button(
                                        icon="ios-cloud-upload-outline"
                                        style="margin-left: 16px;width: 90%;") {{'upload'}}
                        Col(span="12")
                            //- Input(v-model="formItem.groupName" placeholder="Enter something...")
                            div(v-for="(section,key) in initFieldsData" )
                                FormItem(:label="section.label" v-if="section.showInModal")
                                    component(
                                        v-if="section.showInModal"
                                        :is="section.formRender"
                                        v-model="formItem[section.key].defaultVal"
                                        :formData="{}"
                                        :formItem="formItem[section.key]"
                                        :editingItems="editingItems"
                                        :key="formItem[section.key].key"
                                        )
                    Row(type="flex" justify="space-between")
                        Col(span="24" class="formRow")
                            Button(type="primary" style="margin-left: 16px;" @click="addData") {{'Add'}}
                    Row(type="flex" justify="space-between")
                        Table.table(
                            ref="xTable"
                            :key="tabKey"
                            :class="tableHeaderStyle" 
                            :border="withBorder" 
                            style="margin-top: 8px;text-overflow: ellipsis" 
                            :loading="isTableLoading" 
                            :size="tableSize" 
                            :columns="columns" 
                            :data="data")
                            template(slot-scope="{row,index}" slot="action")
                                Button(icon="md-trash" shape="circle" @click="deleteData(index)")
            Row(type="flex" justify="space-between" solt="footer" )
                Col(span="24" class="footer")
                    Button(type="primary" @click="createData") OK
</template>
<script>
import importFun from "./ImportFields.js";
import FormSelect from "./rcmTableFormItems/Select/index.js";
import { _updateData } from "@/api/esdata";

export default {
    name: "ImportBtn",
    components: {
        FormSelect,
    },
    props: {
        searchView: {},
        esIndexFields: {},
        formData: { type: Object, default: {} },
        formInitFieldsData: { type: Array, default: [] },
    },
    data() {
        return {
            isImportModalShown: false,
            isTableLoading: false,
            tableSize: "default",
            accept: ".csv",
            format: [".csv"],
            columns: [],
            data: [],
            initFieldsData: [],
            uploadTimer: null,
            tabKey: 0,
            formItem: {
                groupName: {
                    key: 0,
                    defaultVal: this.$store.state.queryGroupName == "all" ? "" : this.$store.state.queryGroupName,
                    options: [],
                },
                extraUploadData: { directoryPath: [] },
            },
        };
    },
    async created() {
        this.initFields();
        this.setColumns();
    },
    mounted() {},
    methods: {
        addData() {
            let obj = {};
            this.columns.forEach((e) => {
                obj[e.key] = "";
            });
            this.data.push(obj);
            this.setColumns();
            this.setWatch();
        },
        deleteData(index) {
            this.$Modal.confirm({
                title: "移除選項",
                content: `您確定要移除表格第${1 + index}列的選項嗎?`,
                okText: "確定",
                onOk: async () => {
                    this.data.splice(index, 1);
                },
            });
        },
        async createData() {
            let message = this.checkField();
            if (message) {
                this.$Message.warning(message);
                return;
            }
            let esIndex = "rcm-nginxconfigs";
            let action = "create";
            let formData = [].concat(this.data).map((e) => {
                e.groupName = this.formItem.groupName.defaultVal;
                return e;
            });

            let defaultField = this.formInitFieldsData.filter((data) => data.withForm == true);
            formData = formData.map((item) => {
                defaultField.forEach((e) => {
                    if (!item[e.key]) {
                        item[e.key] = e.needTransferUnit ? e.defaultVal.toString() : e.defaultVal;
                    }
                });
                return item;
            });

            let updateData = await _updateData(esIndex, action, formData);
            if (updateData.data.success) {
                this.$Notice.success({
                    title: this.$t("global.success"),
                    desc: `${updateData.data.message}`,
                });
                this.removeData();
                this.isImportModalShown = false;
                this.$emit("searchDomainAtProfile");
            } else {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `${updateData.data.message}`,
                });
            }
        },
        checkField() {
            let errMes = "";

            let serviceGroupNameColumns = this.columns.find((e) => e.key == "serviceGroupName");

            if (this.formItem.groupName.defaultVal == "") {
                errMes += `Please select a group`;
            } else if (this.data.length == 0) {
                errMes += `Please add information`;
            } else {
                let columns = this.columns
                    .map((column) => {
                        return column.key;
                    })
                    .filter((e) => e != "action");
                let fileValue = this.data.find((e, i) => {
                    let files = columns.filter((key) => {
                        if (e[key] == "" || !e[key]) return true;
                    });
                    if (!serviceGroupNameColumns.val[i].find((item) => item.value == e.serviceGroupName)) {
                        return true;
                    }
                    if (files.length > 0) return e;
                });
                if (fileValue) errMes += `Data not yet complete`;
            }

            if (errMes) return errMes;
        },
        removeData() {
            this.data = [];
            this.formItem.groupName.defaultVal =
                this.$store.state.queryGroupName == "all" ? "" : this.$store.state.queryGroupName;
        },
        initFields() {
            var esIndexFieldKeys = Array.isArray(this.esIndexFields)
                ? this.esIndexFields
                : Object.keys(this.esIndexFields);
            this.initFieldsData = importFun(this)
                // 篩選需要的欄位
                .filter(
                    (e) =>
                        (e.searchViews.includes(this.searchView) || e.searchViews[0] == "*") &&
                        esIndexFieldKeys.includes(e.key)
                );
        },
        beforeUpload(file) {
            this.isTableLoading = true;
            let initFieldsDataKey = this.initFieldsData.map((e) => e.key);
            let self = this;
            var reader = new FileReader();
            reader.readAsText(file, "GB2312");
            reader.onload = function () {
                // let result = reader.result.split(/\s+/);
                let result = reader.result.split(/[\n]/);
                let tilte = result[0].split(",");
                let body = result.filter((e, index) => index != 0 && e.length != 0);
                body.forEach((e) => {
                    // let bodyVal = e.split(',"');
                    let bodyVal = e.split('"');
                    let newBodyVal = "";
                    // 處理欄位有,
                    bodyVal.forEach((e, index) => {
                        if (index % 2 != 0) {
                            newBodyVal += e.replace(/\,/g, "&");
                        } else {
                            newBodyVal += e;
                        }
                    });
                    bodyVal = newBodyVal.split(",");
                    let data = {};
                    tilte.forEach((item, index) => {
                        if (initFieldsDataKey.includes(item)) {
                            data[item] = bodyVal[index].replace(/\"/g, "").replace("=", "").replace(/\&/g, ",");
                        }
                    });
                    self.data.push(data);
                });
            };

            clearTimeout(this.uploadTimer);
            this.uploadTimer = setTimeout(function () {
                self.setColumns();
                self.setWatch();
            }, 300);

            return false;
        },
        async setColumns() {
            this.columns = await Promise.all(
                this.initFieldsData.map(async (item) => {
                    // 有remoteOptions 打api取值
                    if (item.remoteOptions) {
                        // showInModal 更改Modal裡元件
                        if (item.showInModal) {
                            let value = await item.remoteOptions("*", {
                                groupNames: this.formItem.groupName.defaultVal,
                            });
                            this.formItem[item.key].options = value;
                            this.formItem[item.key].key += 1;
                        } else {
                            // 更改Table裡元件
                            let val = [];
                            // 將欄位所需的選項放入列裡

                            if (this.data.length == 0) {
                                let value = await item.remoteOptions("*", {
                                    groupNames: this.formItem.groupName.defaultVal,
                                });
                                value = value.map((e) => {
                                    return {
                                        value: e.value ? e.value : e,
                                        label: e.label ? e.label : e,
                                    };
                                });
                                val = [value];
                            } else {
                                val = await Promise.all(
                                    this.data.map(async (e) => {
                                        let value = await item.remoteOptions("*", {
                                            groupNames: this.formItem.groupName.defaultVal,
                                        });
                                        value = value.map((e) => {
                                            return {
                                                value: e.value ? e.value : e,
                                                label: e.label ? e.label : e,
                                            };
                                        });
                                        return value;
                                    })
                                );
                            }
                            item.val = val;
                        }
                    }
                    return item;
                })
            );
            // 排除不再表格顯示欄位
            this.columns = this.columns.filter((e) => e.showInTable);

            // 新增刪除按鈕
            this.columns.push({
                key: "action",
                title: "Action",
                slot: "action",
                width: 150,
                align: "center",
            });
            this.isTableLoading = false;
        },
        setWatch() {
            // 監控表格欄位
            let self = this;
            // 抓取監控欄位
            let watchFields = this.columns
                .map((e, index) => {
                    return { index, data: e };
                })
                .filter((e) => e.data.watchField);
            watchFields.forEach((item) => {
                item.data.queryParamsFields.forEach((field) => {
                    let { fieldName, queryIf } = field;
                    this.data.forEach((column, index) => {
                        this.$watch(
                            function () {
                                let watchVal = column[fieldName];
                                if (this.formItem[fieldName]) {
                                    watchVal = this.formItem[fieldName].defaultVal;
                                }
                                return watchVal;
                            },
                            async function (newVal, oldVal) {
                                // 有條件的獲取新選項;
                                if (queryIf(newVal)) {
                                    //判斷是否重新給下拉值 或 給特定欄位值
                                    // if (self.columns[item.index].val) {
                                    //     column[item.data.key] = "";
                                    //     let value = await item.data.watchField({
                                    //         value: item.data,
                                    //         data: column,
                                    //     });
                                    //     self.columns[item.index].val[index] = value.map((e) => {
                                    //         return {
                                    //             value: e.value ? e.value : e,
                                    //             label: e.label ? e.label : e,
                                    //         };
                                    //     });
                                    //     // self.columns[item.index].val[index] = await item.data.watchField({
                                    //     //     value: item.data,
                                    //     //     data: column,
                                    //     // });
                                    //     this.tabKey++;
                                    // } else {
                                    column[item.data.key] = await item.data.watchField({
                                        value: item.data,
                                        data: column,
                                    });
                                    // }
                                }
                            },
                            { deep: true }
                        );
                    });
                });
            });
        },
    },
    computed: {
        withBorder() {
            return this.$store.getters.getTableConfig.withBorder;
        },
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        editingItems() {
            return { formType: this.formType, items: [] };
        },
    },
    watch: {
        "formItem.groupName.defaultVal": {
            //監聽群組是否異動
            deep: true,
            handler: async function (newVal, oldVal) {
                // let changeField = ["serviceGroupName", "origins", "appProfileName"];
                this.columns = await Promise.all(
                    this.columns.map(async (item) => {
                        // if (changeField.includes(item.key)) {
                        if (item.isWatchField) {
                            let value = await item.remoteOptions("*", {
                                groupNames: this.formItem.groupName.defaultVal,
                            });
                            item.val = item.val.map((e) => value);
                            this.data = this.data.map((e) => {
                                // e[item.key] = "";
                                return e;
                            });
                        }
                        return item;
                    })
                );
            },
        },
    },
};
</script>

<style scoped>
.formRow {
    border-bottom: 1px solid #e8eaec;
    padding: 0px 0px 6px 0px;
    text-align: right;
}
.footer {
    border-top: 1px solid #e8eaec;
    padding: 12px 0px 12px 0px;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/ImportBtn.vue